<aside [ngClass]="{
    'w-56': !isCollapsed,
    'w-12': isCollapsed
  }"
  class="bg-gradient-to-b from-sacred/5 to-white dark:from-stone-900/50 dark:to-stone-800/30 border-r border-grounded/20 dark:border-stone-700/30 h-full transition-all duration-300 ease-in-out overflow-hidden relative shadow-xl backdrop-blur-sm flex flex-col">
  <!-- Floating Sacred Orb -->
  <div
    class="absolute top-4 left-4 w-8 h-8 bg-bloom/20 dark:bg-fuchsia-500/15 rounded-full blur-lg animate-pulse pointer-events-none">
  </div>

  <!-- Toggle Button -->
  <button
    class="absolute top-2 right-1 w-6 h-6 flex items-center justify-center text-rooted/60 dark:text-stone-400 hover:text-soulfire dark:hover:text-fuchsia-400 transition-colors duration-200 hover:bg-sacred/10 dark:hover:bg-stone-700/30 rounded-md z-10 backdrop-blur-sm"
    (click)="toggleSidebar()" [attr.aria-label]="
      isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'
    ">
    @if (!isCollapsed) {
    <i class="pi pi-angle-double-left text-xs font-bold"></i>
    } @else {
    <i class="pi pi-angle-double-right text-xs font-bold"></i>
    }
  </button>

  <!-- Navigation -->
  <nav class="flex-1 flex flex-col pt-8 mt-16 pb-2 px-1 overflow-hidden">
    <ul class="space-y-0.5">
      @for (item of visibleMenuItems; track item.label) {
      <li class="group/item">
        <a [routerLink]="item.route"
          routerLinkActive="bg-gradient-to-r from-soulfire/20 to-bloom/20 dark:from-fuchsia-600/30 dark:to-fuchsia-500/20 text-soulfire dark:text-fuchsia-400 border-soulfire/40 dark:border-fuchsia-500/40 shadow-lg shadow-soulfire/20 dark:shadow-fuchsia-500/20"
          [routerLinkActiveOptions]="{ exact: true }"
          class="sacred-menu-item flex items-center gap-2 px-2 py-1.5 transition-all duration-300 relative overflow-hidden hover:bg-gradient-to-r hover:from-bloom/10 hover:to-soulfire/10 dark:hover:from-fuchsia-500/10 dark:hover:to-fuchsia-600/10 hover:text-soulfire dark:hover:text-fuchsia-400 rounded-lg text-sm backdrop-blur-sm border border-transparent hover:border-bloom/20 dark:hover:border-fuchsia-500/20 text-rooted/70 dark:text-stone-300"
          [attr.title]="isCollapsed ? item.label : ''" (click)="item.label === 'New Conversation' ? startNewChat() : null">
          <!-- Sacred Icon -->
          <div class="relative z-10 flex items-center justify-center w-4 h-4 flex-shrink-0">
            <i [ngClass]="item.icon"
              class="text-xs transition-colors duration-300 drop-shadow-sm text-rooted/70 dark:text-stone-300 group-hover/item:text-soulfire dark:group-hover/item:text-fuchsia-400"></i>
          </div>

          <!-- Sacred Label -->
          @if (!isCollapsed) {
          <span
            class="relative z-10 text-rooted dark:text-stone-200 group-hover/item:text-soulfire dark:group-hover/item:text-fuchsia-400 font-medium transition-all duration-300 whitespace-nowrap text-xs flex-1">
            {{ item.label }}
          </span>
          }

          <!-- Divine Badge -->
          @if (!isCollapsed && item.badge) {
          <span
            class="ml-auto bg-gradient-to-r from-soulfire to-bloom dark:from-fuchsia-600 dark:to-fuchsia-500 text-white text-[10px] px-1.5 py-0.5 rounded-full font-medium min-w-[16px] text-center leading-none shadow-lg">
            {{ item.badge }}
          </span>
          }

          <!-- Sacred Tooltip for collapsed mode -->
          @if (isCollapsed) {
          <div
            class="tooltip absolute left-full ml-2 bg-gradient-to-r from-rooted to-soulfire dark:from-stone-700 dark:to-fuchsia-600 text-white px-2 py-1 rounded-lg text-[10px] whitespace-nowrap opacity-0 invisible group-hover/item:opacity-100 group-hover/item:visible transition-all duration-300 z-50 shadow-xl backdrop-blur-sm">
            {{ item.label }}
            <div
              class="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-rooted dark:border-r-stone-700">
            </div>
          </div>
          }

          <!-- Sacred Glow Effect -->
          <div
            class="absolute inset-0 bg-gradient-to-r from-bloom/5 to-soulfire/5 dark:from-fuchsia-500/5 dark:to-fuchsia-600/5 opacity-0 group-hover/item:opacity-100 transition-opacity duration-300 rounded-lg">
          </div>
        </a>
      </li>
      }
    </ul>

    <!-- Chat History Section (Users Only) -->
    @if (!isAdmin && !isSubadmin && !isCollapsed){
    <div
      class="mt-4 border-t border-grounded/20 dark:border-stone-700/30 pt-3 flex-1 flex flex-col overflow-hidden mb-12 relative">
      <!-- Sacred Header with divine refresh -->
      <div class="px-2 mb-2 flex items-center justify-between">
        <h3 class="text-[10px] font-semibold text-rooted/70 dark:text-stone-400 uppercase tracking-wide">
          Your Conversations
        </h3>
        <button (click)="refreshChatHistory()" [disabled]="isRefreshing || isInitialLoading"
          class="text-rooted/50 dark:text-stone-500 hover:text-soulfire dark:hover:text-fuchsia-400 transition-colors duration-300 disabled:opacity-50 hover:scale-110 transform"
          title="Refresh chat history">
          <i class="pi pi-refresh text-xs drop-shadow-sm" [class.animate-spin]="isRefreshing"></i>
        </button>
      </div>

      <!-- Chat History Container with Infinite Scroll -->
      <div class="flex-1 overflow-hidden flex flex-col min-h-0">
        <div #scrollContainer
          class="flex-1 overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-bloom/30 dark:scrollbar-thumb-fuchsia-500/30 scrollbar-track-transparent hover:scrollbar-thumb-soulfire/50 dark:hover:scrollbar-thumb-fuchsia-400/50"
          (scroll)="onScroll($event)">
          <!-- Loading State -->
          @if (isInitialLoading) {
          <div class="space-y-2 p-2">
            @for (item of skeletonItems; track $index) {
            <div class="animate-pulse">
              <div
                class="flex items-start gap-2 p-2 rounded-lg bg-gradient-to-r from-sacred/10 to-bloom/5 dark:from-stone-700/30 dark:to-fuchsia-500/10">
                <div
                  class="w-4 h-4 bg-gradient-to-br from-bloom/30 to-soulfire/30 dark:from-fuchsia-500/40 dark:to-fuchsia-600/40 rounded flex-shrink-0 mt-0.5">
                </div>
                <div class="flex-1 min-w-0">
                  <div
                    class="h-3 bg-gradient-to-r from-bloom/20 to-soulfire/20 dark:from-fuchsia-500/30 dark:to-fuchsia-600/30 rounded mb-2"
                    [style.width.%]="item.titleWidth"></div>
                  <div class="flex items-center justify-between">
                    <div class="h-2 bg-sacred/20 dark:bg-stone-600/40 rounded flex-1 mr-2"
                      [style.width.%]="item.previewWidth"></div>
                    <div class="h-2 bg-grounded/20 dark:bg-stone-700/40 rounded w-8"></div>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
          }

          <!-- Chat History List -->
          @if (!isInitialLoading) {
          <ul class="space-y-0.5">
            @for (chat of chatHistories; track chat._id) {
            <li class="group/item">
              <button (click)="loadChat(chat._id)" [class]="
                  currentChatId === chat._id
                    ? 'bg-gradient-to-r from-bloom/20 to-soulfire/20 dark:from-fuchsia-600/20 dark:to-fuchsia-500/20 text-soulfire dark:text-fuchsia-400 border-bloom/30 dark:border-fuchsia-500/30 shadow-inner'
                    : 'text-rooted dark:text-stone-300 hover:bg-gradient-to-r hover:from-sacred/10 hover:to-bloom/10 dark:hover:from-stone-700/20 dark:hover:to-fuchsia-500/10 hover:text-soulfire dark:hover:text-fuchsia-400 border-transparent'
                "
                class="w-full text-left px-2 py-2 transition-all duration-300 relative overflow-hidden rounded-lg text-xs group border backdrop-blur-sm hover:shadow-lg hover:scale-[1.02]"
                [attr.title]="chat.title">
                <div class="flex items-start gap-2">
                  <div class="relative z-10 flex items-center justify-center w-4 h-4 flex-shrink-0 mt-0.5">
                    <i class="pi pi-comments text-xs transition-colors duration-300 drop-shadow-sm"></i>
                  </div>

                  <div class="flex-1 min-w-0">
                    <!-- Chat Title -->
                    <div class="font-medium transition-all duration-300 text-xs truncate leading-tight">
                      {{ getTruncatedTitle(chat.title) }}
                    </div>

                    <!-- Message preview and timestamp -->
                    <div class="flex items-center justify-between mt-1">
                      @if (chat.messages && chat.messages.length > 0) {
                      <span class="text-[10px] text-rooted/60 dark:text-stone-400 truncate flex-1 pr-1">
                        {{
                        chat.messages[chat.messages.length - 1].content
                        | slice : 0 : 20
                        }}{{
                        chat.messages[chat.messages.length - 1].content
                        .length > 20
                        ? "..."
                        : ""
                        }}
                      </span>
                      }
                      <span class="text-[9px] text-rooted/40 dark:text-stone-500 whitespace-nowrap">
                        {{ getFormattedDate(chat.lastUpdated) }}
                      </span>
                    </div>
                  </div>
                  <!-- Delete button -->
                  <button (click)="showDeleteDialog(chat._id, chat.title, $event)"
                    class="opacity-0 group-hover:opacity-100 text-rooted/40 dark:text-stone-500 hover:text-red-500 dark:hover:text-red-400 transition-all duration-300 p-0.5 mt-0.5 hover:scale-110 transform"
                    title="Delete conversation">
                    <i class="pi pi-trash text-xs drop-shadow-sm"></i>
                  </button>
                </div>

                <!-- Sacred Glow Effect -->
                <div
                  class="absolute inset-0 bg-gradient-to-r from-bloom/5 to-soulfire/5 dark:from-fuchsia-500/5 dark:to-fuchsia-600/5 opacity-0 group-hover/item:opacity-100 transition-opacity duration-300 rounded-lg pointer-events-none">
                </div>
              </button>
            </li>
            }

            <!-- Loading More Skeleton -->
            @if (isLoadingMore) {
            <div class="space-y-2 py-2">
              @for (item of loadMoreSkeletonItems; track $index) {
              <li class="animate-pulse">
                <div
                  class="flex items-start gap-2 p-2 rounded-lg bg-gradient-to-r from-sacred/10 to-bloom/5 dark:from-stone-700/30 dark:to-fuchsia-500/10">
                  <div
                    class="w-4 h-4 bg-gradient-to-br from-bloom/30 to-soulfire/30 dark:from-fuchsia-500/40 dark:to-fuchsia-600/40 rounded flex-shrink-0 mt-0.5">
                  </div>
                  <div class="flex-1 min-w-0">
                    <div
                      class="h-3 bg-gradient-to-r from-bloom/20 to-soulfire/20 dark:from-fuchsia-500/30 dark:to-fuchsia-600/30 rounded mb-2"
                      [style.width.%]="item.titleWidth"></div>
                    <div class="flex items-center justify-between">
                      <div class="h-2 bg-sacred/20 dark:bg-stone-600/40 rounded flex-1 mr-2"
                        [style.width.%]="item.previewWidth"></div>
                      <div class="h-2 bg-grounded/20 dark:bg-stone-700/40 rounded w-8"></div>
                    </div>
                  </div>
                </div>
              </li>
              }
            </div>
            }
          </ul>
          }

          <!-- Empty State -->
          @if (!isInitialLoading && !isLoadingMore && chatHistories.length ===
          0) {
          <div class="flex flex-col items-center justify-center py-8 text-center relative">
            <div
              class="absolute inset-0 bg-gradient-to-br from-sacred/5 to-bloom/5 dark:from-stone-800/20 dark:to-fuchsia-500/10 rounded-lg">
            </div>
            <i class="pi pi-comments text-2xl text-rooted/30 dark:text-stone-500 mb-2 relative z-10 drop-shadow-sm"></i>
            <p class="text-xs text-rooted/60 dark:text-stone-400 relative z-10">
              No conversations yet
            </p>
            <p class="text-[10px] text-rooted/40 dark:text-stone-500 mt-1 relative z-10">
              Start your first conversation
            </p>
          </div>
          }
        </div>

        <!-- Load More Button Section -->
        @if (!isInitialLoading && hasMoreChats && chatHistories.length > 0) {
        <div
          class="flex-shrink-0 px-2 py-2 border-t border-grounded/20 dark:border-stone-700/30 bg-gradient-to-b from-white to-sacred/5 dark:from-stone-800/50 dark:to-stone-900/20 backdrop-blur-sm">
          <button (click)="loadMoreConversations()" [disabled]="isLoadingMore || isRefreshing"
            class="w-full text-center py-2 px-3 text-xs font-medium text-soulfire dark:text-fuchsia-400 hover:text-bloom dark:hover:text-fuchsia-300 hover:bg-gradient-to-r hover:from-bloom/10 hover:to-soulfire/10 dark:hover:from-fuchsia-500/10 dark:hover:to-fuchsia-600/10 border border-bloom/30 dark:border-fuchsia-500/30 hover:border-soulfire/50 dark:hover:border-fuchsia-400/50 rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-soulfire dark:disabled:hover:text-fuchsia-400 disabled:hover:border-bloom/30 dark:disabled:hover:border-fuchsia-500/30 backdrop-blur-sm shadow-sm">
            @if (isLoadingMore) {
            <div class="flex items-center justify-center gap-1">
              <i class="pi pi-spinner text-xs animate-spin drop-shadow-sm"></i>
              <span>Loading...</span>
            </div>
            } @else {
            <div class="flex items-center justify-center gap-1">
              <i class="pi pi-chevron-down text-xs drop-shadow-sm"></i>
              <span>Load More Conversations ({{
                remainingConversationsCount
                }})</span>
            </div>
            }
          </button>
        </div>
        }

        <!-- End Indicator -->
        @if (!hasMoreChats && chatHistories.length > 0 && !isInitialLoading) {
        <div
          class="flex-shrink-0 px-2 py-2 border-t border-grounded/20 dark:border-stone-700/30 bg-gradient-to-b from-white to-sacred/5 dark:from-stone-800/50 dark:to-stone-900/20 backdrop-blur-sm">
          <div class="text-center">
            <span class="text-[10px] text-rooted/40 dark:text-stone-500">All conversations loaded</span>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </nav>

  <!-- Sidebar Footer -->
  @if (!isCollapsed) {
  <div
    class="flex-shrink-0 px-2 py-3 border-t border-grounded/20 dark:border-stone-700/30 bg-gradient-to-r from-sacred/10 to-bloom/10 dark:from-stone-800/30 dark:to-fuchsia-500/10 backdrop-blur-sm text-[10px] text-rooted/60 dark:text-stone-400 text-center">
    <div class="flex items-center justify-center gap-1">
      <i class="pi pi-heart text-bloom dark:text-fuchsia-400 text-xs"></i>
      <span>v{{ appVersion }} &copy; {{ currentYear }}</span>
    </div>
    <span>T.O. Grow4Life Technology AB</span>
  </div>
  }
</aside>

<!-- Delete Confirmation Dialog -->
<app-confirmation-dialog [visible]="showDeleteConfirmation()" title="Delete Conversation"
  [message]="deleteConfirmationMessage" confirmText="Delete" cancelText="Cancle" icon="pi-heart-fill"
  (confirmed)="onDeleteConfirmed()" (cancelled)="onDeleteCancelled()"
  (visibilityChanged)="onDialogVisibilityChanged($event)"></app-confirmation-dialog>